import React, { useState } from 'react';

import { MenuPinType } from '../../../../shared/interfaces';
import AssignedDriverIcon from '../../../../assets/svg/driver_24px.svg';
import { friendlyDiff } from "../../../../shared/helpers";
import * as devicedb from "../../../../shared/db/devices-db";
import { Link } from "react-router-dom";
import moment from 'moment';
import LocalPersonTile from '../../PersonTabPage/LocalPeopleTile';

export const DeviceAssignedDriver = ({ deviceId, isPinned, isDriverDevice, isDriver, assignedPerson, authUser, assignedPersonId, device, isReadOnly, title, cssOrder, showPin }) => {
  const [collapsed, setCollapsed] = useState<boolean>(isPinned);


  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title={title}
      action={null}
      isPinned={isPinned}
      withPin={showPin}
      property={MenuPinType.ASSIGNED_DRIVER}
      order={cssOrder}
      leftIcon={null}
    >
      <div>
        {assignedPerson ?
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 4 }}>
            <span>{assignedPerson.displayName}</span>
            <span>{friendlyDiff(moment(), (device as any).assignedTo.time)}</span>
            <button
              className="btn btn-primary btn-xs"
              onClick={(_) => devicedb.unAssignDevice(authUser)(deviceId, assignedPersonId)}
              disabled={!isDriverDevice && isDriver || isReadOnly}
            >
              Tap Out
            </button>
          </div> :
          isDriver ?
            <button
              disabled={isReadOnly}
              className="btn btn-primary"
              onClick={(_) => devicedb.assignDevice(authUser)(deviceId, authUser.uid)}
            >
              Tap in
            </button> :
            isReadOnly
              ? <p>You dont have permission to assing a driver</p>
              : <Link to={`/device/${deviceId}/assign`} className="btn btn-xs btn-primary">Assign to Person</Link>
        }
      </div>
    </LocalPersonTile>
  )
};
